export default __webpack_public_path__ + "static/media/cabin.5e12b830.jpg";